import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { downloadFile, showMessageToast, translate, formatData, isNullOrEmpty } from '../../../../utils/util';
import SecurityService from '../../../../services/SecurityService';
import { getVision } from '../../../../services/auth';
import { VISIONS } from '../../../../utils/constants';
import { SelectResource, Modal } from '../../../../components/UI/ComponentsUI';
import useStateWithPromise from '../../../../utils/useEffectUpdate';
import StockService from '../../../../services/StockService';
import ConfirmModalUI from '../../../../components/UI/ConfirmModalUI';

const MaterialItemsPab = (props) => {
    const [openModal, setOpenModal] = useStateWithPromise(false);
    const [item, setItem] = useStateWithPromise();
    const [messageModal, setMessageModal] = useState({ open: false, messages: [] });

    const redirectDropBarCode = () => {

        props.history.push({
            state: {
                barcode: true,
                pabReplanning: true,
                dataParams: props.item,
                disable: true
            },
            pathname: '../stock/drop'
        });


    }


    const renderSelectResource = () => {
        return (
            <div id="renderSelectResource" className='row'>
                <div className="col s12" style={{ paddingBottom: '5px', paddingTop: '10px' }}>
                    <div className="input-field col s12">
                        <SelectResource
                            loadConfigLaser={getVision() === VISIONS.Jeep}
                            required
                            name="resource"
                            id="resource"
                            value={props.user?.resource} />
                    </div>
                    <div className="col s12" style={{ paddingBottom: '5px', paddingTop: '20px' }}>
                        {translate('message-report-print', 'physical-confirmation')}
                    </div>
                </div>
            </div>
        );
    }

    const onClickItem = () => {
        let printer = props.user.printer;
        if (!printer) {
            return showMessageToast({ html: translate('select-resource', 'validations'), classes: 'red' });
        }
        props.printLabel({
            itemLabel: props.item,
            printer: printer
        })
        setItem();
    }

    const downloadReport = () => {
        props.getReportLabelsPdf({
            itemLabel: props.item
        }, (response) => {
            if (response) {
                downloadFile(response, `Label.pdf`, "data:application/pdf", true)

            }
        });
    }

    return (
        <>
            <div>
                {
                    !isNullOrEmpty(props.item.cim) &&
                    <>
                        <span title={translate('stock:write-off-by-barcode')}
                            key={`${props.item.index}-barcode`}
                            className="title sixth-text-color right"
                            style={{ position: 'absolute', right: '20px', marginTop: `10px` }}
                            onClick={(event) => {
                                event.preventDefault();
                                redirectDropBarCode();

                            }}
                        ><i style={{ cursor: 'pointer' }} className='mdi mdi-36px mdi-arrow-down-bold-circle-outline' />
                        </span>
                    </>
                }
            </div>
            <div
                className="row"
                style={{ display: 'block', margin: '5px' }}
            >
                {!isNullOrEmpty(props.item.orderCodePab) &&
                    <div className="col s10 " style={{ padding: '0px' }}>
                        <span className="title sixth-text-color"> {`TD : ${props.item.orderCodePab || ""}`}</span>
                    </div>
                }
                <div className="col s10 " style={{ padding: '0px' }}>
                    <span className="title sixth-text-color">{`${translate('stock:partnumber')} : ${props.item.partNumberCode || ""}`}</span>
                </div>
                <div className="col s10">
                    <span className="truncate second-text-color">{`${translate('stock:description')} : ${props.item.partNumberDescription || ""}`} </span>
                </div>
                {!isNullOrEmpty(props.item.supplier) &&
                    <div className="col s12 ">
                        <span className="truncate second-text-color"> {`${translate('expedition:picking.supplier')} : ${props.item.supplier || ""}-${props.item.supplierName || ""}`}</span>
                    </div>
                }
                {!isNullOrEmpty(props.item.mdr) &&
                    <div className="col s12">
                        <span className="truncate second-text-color">{`${translate('change-location:mdr')} : ${props.item.mdr || ""}`} </span>
                    </div>
                }
                <div className="col s12">
                    <span className="truncate second-text-color"> {`${translate('stock:location')} : ${props.item.location || props.item.locationTarget}`} </span>
                </div>
                {!isNullOrEmpty(props.item.cim) &&
                    <div className="col s10">
                        <span className="truncate second-text-color"> {`${translate('stock:cim')} : ${props.item.cim || ""}`} </span>
                    </div>
                }
                {props.item.allocationDate &&
                    <div className="col s10">
                        <span className="truncate second-text-color"> {`${translate('stock:allocationDate')} : ${formatData(props.item.allocationDate) || ""}`} </span>
                    </div>
                }

                <div className="col s12">
                    <span className="truncate second-text-color">  {`${translate('stock:quantity')} ${props.showCimQtd ? "TD" : ""} : ${props.item.qtd || ""}`}</span>
                </div>
                {!isNullOrEmpty(props.item.qtdCim) && props.showCimQtd &&
                    <div className="col s12">
                        <span className="truncate second-text-color">  {`${translate('stock:quantity')} Cim : ${props.item.qtdCim || "0"}`}</span>
                    </div>
                }
                {!isNullOrEmpty(props.item.orderCodeStatus) &&
                    <div className="col s12">
                        <span className="truncate second-text-color"> {`${translate('general:status')} : ${props.item.orderCodeStatus || ""}`} </span>
                    </div>
                }
            </div>
            <Modal
                open={openModal}
                id="modalPrintLocation"
                content={'Imprimir Etiqueta'}
                children={renderSelectResource()}
                dismissible={false}
                onConfirm={() => {
                    onClickItem();
                    setOpenModal(false)
                }}
                onCancel={() => {
                    downloadReport(item);
                    setOpenModal(false)
                }}
                closeModal={() => {
                    setOpenModal(false);
                    setItem()
                }}
                btnConfirm="Enviar Impressora"
                btnCancel="Baixar"
            />
            <ConfirmModalUI
                open={messageModal.open}
                id="messageModalErro"
                data={{
                    title: translate('validations:attention'),
                    message: <>
                        <div className="input-field no-padding col s6">
                            <div style={{ display: 'flex', flexDirection: 'column', padding: '15px 0px' }}>
                                {
                                    messageModal.messages.map((message, index) => {
                                        return (
                                            <span key={index} className="title col s8" style={{ fontSize: '1rem', color: 'red' }}>
                                                {message}
                                            </span>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </>
                }}
                showCancel={false}
                onClose={() => {
                    messageModal.open = false;
                    messageModal.messages = [];
                    setMessageModal({ ...messageModal });
                }}
                btnConfirm={translate('close', 'general')}
            />
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        resources: state.logisticsResourceReducer.list,
        sheds: state.configReducer.sheds,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setResource: (resource) => {
            dispatch(SecurityService.setResource(resource));
        },
        setPrinter: (printer) => {
            dispatch(SecurityService.setPrinter(printer));
        },
        printLabel: (model, callback) => {
            dispatch(StockService.printLabelSearch(model, callback));
        },
        getReportLabelsPdf: (model, callback) => {
            dispatch(StockService.getReportLabelsPdf(model, callback));
        },
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MaterialItemsPab)));
